export default __webpack_public_path__ + "static/media/tonedevs-logo-temp.28438cbf.png";